import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { RegionSchema } from '../../base/region.js';
export const GetRegionApiSchema = {
    params: z.object({
        regionId: RegionSchema.shape.id,
    }),
    headers: ApiLambdalerAuthHeaderSchema,
    response: z.object({
        region: RegionSchema,
    }),
};
